import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "filter-box" }
const _hoisted_4 = { class: "filter-box" }
const _hoisted_5 = { class: "filter-box" }
const _hoisted_6 = { class: "filter-box" }
const _hoisted_7 = { class: "filter-box" }
const _hoisted_8 = { class: "filter-box" }
const _hoisted_9 = { class: "filter-box" }
const _hoisted_10 = { class: "filter-box" }
const _hoisted_11 = { class: "filter-box" }
const _hoisted_12 = { class: "filter-box" }
const _hoisted_13 = { class: "filter-box" }
const _hoisted_14 = { class: "filter-box" }
const _hoisted_15 = { class: "filter-box" }
const _hoisted_16 = { class: "form-title mt-30 mb-10" }
const _hoisted_17 = { class: "left" }
const _hoisted_18 = { class: "underlineForm" }
const _hoisted_19 = { class: "dialog-footer" }
const _hoisted_20 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_MiniBusinessList = _resolveComponent("MiniBusinessList")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_ChargeFee = _resolveComponent("ChargeFee")!
  const _directive_waves = _resolveDirective("waves")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.isFilterCollapse)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_3, [
                _cache[26] || (_cache[26] = _createElementVNode("span", { class: "label" }, "外包商", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.outsourceCompany,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listQuery.outsourceCompany) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _cache[27] || (_cache[27] = _createElementVNode("span", { class: "label" }, "发票号码", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.invoiceNo,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listQuery.invoiceNo) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[28] || (_cache[28] = _createElementVNode("span", { class: "label" }, "公司名称", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.companyName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listQuery.companyName) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[29] || (_cache[29] = _createElementVNode("span", { class: "label" }, "业务编号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.businessNo,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listQuery.businessNo) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[30] || (_cache[30] = _createElementVNode("span", { class: "label" }, "业务名称", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.businessName,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.listQuery.businessName) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[31] || (_cache[31] = _createElementVNode("span", { class: "label" }, "型号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.businessModel,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.listQuery.businessModel) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[32] || (_cache[32] = _createElementVNode("span", { class: "label" }, "业务代表", -1)),
                _createVNode(_component_el_select, {
                  filterable: true,
                  modelValue: _ctx.listQuery.salesManId,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.listQuery.salesManId) = $event)),
                  class: "filter-item",
                  placeholder: "",
                  clearable: "",
                  size: _ctx.t('table.btnSize'),
                  onFocus: _ctx.handleSalesManFocus,
                  onChange: _ctx.handleFilter
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.salesManOption, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.mark,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "size", "onFocus", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[33] || (_cache[33] = _createElementVNode("span", { class: "label" }, "登记时间", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.startTime,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.listQuery.startTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[34] || (_cache[34] = _createElementVNode("span", { class: "label" }, "到", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.endTime,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.listQuery.endTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[35] || (_cache[35] = _createElementVNode("span", { class: "label" }, "付款时间", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.payStartTime,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.listQuery.payStartTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[36] || (_cache[36] = _createElementVNode("span", { class: "label" }, "到", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.payEndTime,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.listQuery.payEndTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.listQuery.status,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.listQuery.status) = $event)),
                  onChange: _ctx.handleFilter
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: "4" }, {
                      default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                        _createTextVNode("待付款", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "6" }, {
                      default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                        _createTextVNode("已付款", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "7" }, {
                      default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                        _createTextVNode("退款中", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "8" }, {
                      default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                        _createTextVNode("已退款", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "" }, {
                      default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                        _createTextVNode("全部", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_15, [
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleFilter
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.search")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleCommand('add')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.add")), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_ADD` }]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleCommand('batch-payOk')))
          }, {
            default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
              _createTextVNode(" 批量付款 ", -1)
            ]))]),
            _: 1
          }, 8, ["size"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_PAYOK` }]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "warning",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleCommand('batch-refundOk')))
          }, {
            default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
              _createTextVNode(" 批量退款确认 ", -1)
            ]))]),
            _: 1
          }, 8, ["size"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_PAYOK` }]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleReset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.reset")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.isFilterCollapse = !_ctx.isFilterCollapse))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isFilterCollapse ? '展开' : '收起'), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_waves]
          ]),
          _createElementVNode("span", {
            class: "svg-icon cursor mr-10 ml-10",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleCommand('refresh')))
          }, [...(_cache[44] || (_cache[44] = [
            _createElementVNode("i", { class: "icon-tubiao-27 iconfont" }, null, -1)
          ]))]),
          _createElementVNode("span", {
            class: "svg-icon cursor",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleCommand('column')))
          }, [...(_cache[45] || (_cache[45] = [
            _createElementVNode("i", { class: "icon-tubiao-28 iconfont" }, null, -1)
          ]))]),
          _cache[46] || (_cache[46] = _createStaticVNode("<span class=\"ml-10 filter-mark\"><span class=\"status-item\"><span class=\"status-square\" style=\"background-color:red;\"></span><span class=\"status-text\">待付款且业务未收款</span></span><span class=\"status-item\"><span class=\"status-square\" style=\"background-color:blue;\"></span><span class=\"status-text\">待付款且业务已收款</span></span></span>", 1))
        ])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_TableList, {
        ref: "tableDataRef",
        dataList: _ctx.list,
        columnAllData: _ctx.columnAllData,
        tableName: _ctx.TableName,
        permissionName: _ctx.permissionName,
        tableRowClassName: _ctx.tableRowClassName,
        isShowPagination: false,
        showSelection: true,
        showSummary: true,
        handleDefaultWidth: 160,
        onCommandChange: _ctx.handleCommand
      }, {
        "operation-action": _withCtx((scope) => [
          (scope.row.status === '审批通过-待付款' || scope.row.status === '无需审批-待付款')
            ? _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                key: 0,
                href: "javascript:void(0);",
                class: "mr-10",
                type: "primary",
                disabled: !!_ctx.payBlockedReason(scope.row),
                title: _ctx.payBlockedReason(scope.row),
                onClick: ($event: any) => (_ctx.handleCommand('PAYOK', scope.row))
              }, {
                default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                  _createTextVNode(" 付款 ", -1)
                ]))]),
                _: 1
              }, 8, ["disabled", "title", "onClick"])), [
                [_directive_permission, { pkey: `${_ctx.permissionName}_PAYOK` }]
              ])
            : _createCommentVNode("", true),
          (Number(scope.row.paid || 0) > 0 || scope.row.status === '完成' || scope.row.status === '退款中')
            ? _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                key: 1,
                href: "javascript:void(0);",
                class: "mr-10",
                type: "warning",
                onClick: ($event: any) => (_ctx.handleCommand('REFUNDOK', scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.row.status === '退款中' ? '退款确认' : '退款'), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_permission, { pkey: `${_ctx.permissionName}_PAYOK` }]
              ])
            : _createCommentVNode("", true),
          _withDirectives((_openBlock(), _createBlock(_component_el_link, {
            href: "javascript:void(0);",
            class: "mr-10",
            type: "primary",
            onClick: ($event: any) => (_ctx.handleCommand('paid-record', scope.row))
          }, {
            default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
              _createTextVNode(" 明细 ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_PAID_RECORD` }]
          ])
        ]),
        _: 1
      }, 8, ["dataList", "columnAllData", "tableName", "permissionName", "tableRowClassName", "onCommandChange"])), [
        [_directive_loading, _ctx.listLoading]
      ]),
      _withDirectives(_createVNode(_component_el_pagination, {
        class: "mt-20",
        total: _ctx.total,
        currentPage: _ctx.listQuery.page,
        "onUpdate:currentPage": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.listQuery.page) = $event)),
        "page-size": _ctx.listQuery.size,
        "page-sizes": _ctx.pageSizes,
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        layout: "total, sizes, prev, pager, next"
      }, null, 8, ["total", "currentPage", "page-size", "page-sizes", "onSizeChange", "onCurrentChange"]), [
        [_vShow, _ctx.total > 0]
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.dialogFormVisible) = $event)),
      title: _ctx.dialogTitle,
      width: "80%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_19, [
          _createVNode(_component_el_button, {
            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.dialogFormVisible = false)),
            type: "danger"
          }, {
            default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.handleSubmit
          }, {
            default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
              _createTextVNode("确定", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_MiniBusinessList, {
          businessList: _ctx.selectionRowList,
          ref: "miniBusinessList"
        }, {
          before: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "no",
              label: "编号",
              "show-overflow-tooltip": "",
              width: "120"
            }),
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: "名称",
              "show-overflow-tooltip": "",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              prop: "brand",
              label: "品牌",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "fee",
              label: "总费用",
              "show-overflow-tooltip": "",
              align: "right",
              "min-width": "100"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_ctx.$currency(row.fee)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "paid",
              label: "已付费用",
              "show-overflow-tooltip": "",
              align: "right",
              "min-width": "100"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_ctx.$currency(row.paid)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "paidAmount",
              label: _ctx.currentCommand === 'refund' ? '本次退款' : '费用',
              "show-overflow-tooltip": "",
              align: "right",
              "min-width": "160"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input_number, {
                  modelValue: row.paidAmount,
                  "onUpdate:modelValue": ($event: any) => ((row.paidAmount) = $event),
                  type: "number",
                  min: 0.01,
                  max: _ctx.currentCommand === 'refund' ? Number(row.paid) : Number(row.fee - row.paid),
                  precision: 2,
                  "controls-position": "right",
                  onChange: ($event: any) => (_ctx.handleFeeInput(row)),
                  onInput: ($event: any) => (_ctx.handleFeeInput(row))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "onChange", "onInput"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "remainAmount",
              label: _ctx.currentCommand === 'refund' ? '退后净付' : '待付费用',
              "show-overflow-tooltip": "",
              align: "right",
              width: "100"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_ctx.$currency(row.remainAmount)), 1)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          after: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "businessAmount",
              label: "数量",
              width: "60"
            }),
            _createVNode(_component_el_table_column, {
              prop: "salesMan",
              label: "业务代表",
              width: "100",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "customerCompany",
              label: "客户公司",
              width: "100",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "ticketCompany",
              label: "所属公司",
              width: "100",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "invoiceStatus",
              label: "开票状态",
              width: "100",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.invoiceStatus), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "unit",
              label: "单位",
              width: "60"
            }),
            _createVNode(_component_el_table_column, {
              prop: "model",
              label: "型号",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "serial",
              label: "序列号",
              "show-overflow-tooltip": ""
            })
          ]),
          _: 1
        }, 8, ["businessList"]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("span", {
            class: _normalizeClass(["label", _ctx.currentCommand === 'refund' ? 'yellow' : 'green'])
          }, _toDisplayString(_ctx.currentCommand === 'refund' ? '退' : '付'), 3),
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.currentCommand === 'refund' ? '退款确认' : '付款确认'), 1)
        ]),
        _createVNode(_component_el_form, {
          ref: "dataForm",
          model: _ctx.formData,
          rules: _ctx.rules,
          "label-position": "top",
          "label-width": "100px",
          class: "mb-20"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_el_form_item, {
                label: _ctx.currentCommand === 'refund' ? '收款账户' : '付款账户',
                prop: "paymentAccountId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    filterable: true,
                    modelValue: _ctx.formData.paymentAccountId,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.paymentAccountId) = $event)),
                    class: "filter-item",
                    placeholder: "输入关键字搜索",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.mark,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _ctx.currentCommand === 'refund' ? '退款时间' : '付款时间',
                prop: "paymentTime"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.formData.paymentTime,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.paymentTime) = $event)),
                    type: "date",
                    placeholder: " ",
                    format: "YYYY-MM-DD",
                    "value-format": "YYYY-MM-DD",
                    size: _ctx.t('table.btnSize')
                  }, null, 8, ["modelValue", "size"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _ctx.currentCommand === 'refund' ? '退款备注' : '付款备注',
                prop: "paymentMark",
                class: "fullWidth"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.paymentMark,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.paymentMark) = $event)),
                    placeholder: " ",
                    type: "textarea"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.paidRecordVisible,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.paidRecordVisible) = $event)),
      title: "明细",
      width: "60%",
      "close-on-click-modal": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_20, [
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.paidRecordVisible = false))
          }, {
            default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
              _createTextVNode("关闭", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_ChargeFee, {
          id: _ctx.activeId,
          api: "outsourceFee"
        }, null, 8, ["id"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}